var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-stepper-content", { attrs: { step: "3" } }, [
    _c(
      "div",
      { staticClass: "d-flex flex-column" },
      [
        _c(
          "div",
          { staticClass: "d-flex justify-space-between" },
          [
            _c("v-text-field", {
              attrs: { "data-cy": "s3BucketName", label: "Bucket name" },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.load.apply(null, arguments)
                },
              },
              model: {
                value: _vm.formBucketName,
                callback: function ($$v) {
                  _vm.formBucketName = $$v
                },
                expression: "formBucketName",
              },
            }),
            _c(
              "v-btn",
              {
                staticClass: "fill-height pa-0",
                attrs: {
                  "data-cy": "s3LoadBucket",
                  title: "Query the S3 bucket",
                  disabled: _vm.formBucketName.length < 1,
                },
                on: { click: _vm.load },
              },
              [_c("v-icon", [_vm._v("mdi-cloud-download")])],
              1
            ),
          ],
          1
        ),
        _c(
          "v-list",
          { attrs: { "data-cy": "s3FileList", "two-line": true } },
          [
            _vm.files.length === 0
              ? _c("v-list-item", [
                  _vm._v("No items found! Try different terms?"),
                ])
              : _vm._e(),
            _vm._l(_vm.files, function (val, index) {
              return _c(
                "v-list-item",
                { key: val.Key },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [_vm._v(_vm._s(val.Key))]),
                      _c("v-list-item-subtitle", [
                        _vm._v(" " + _vm._s(val.LastModified) + " "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-action",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            "data-cy": "s3LoadFile",
                            title: "Load into Heimdall",
                            icon: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.loadFile(index)
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-plus-circle")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
          ],
          2
        ),
        _c(
          "v-btn",
          {
            staticClass: "my-2 mr-3",
            attrs: { color: "red" },
            on: {
              click: function ($event) {
                return _vm.$emit("exit-list")
              },
            },
          },
          [_vm._v(" Cancel ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }